import { createFeatureSelector, createSelector } from '@ngrx/store'
import { ILoadingState } from '@adex/shared/models/states/loading.state'


const selectLoadingState = createFeatureSelector<ILoadingState>('loadingState')
export const selectLoading = (url: string) => createSelector(selectLoadingState, state => state[url])
